import Box, { type BoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { forwardRef } from 'react';

type ImageProps = BoxProps<'img'>;

const BaseImage = forwardRef((props: ImageProps, ref) => (
  <Box component='img' {...props} ref={ref} />
));
BaseImage.displayName = 'Image';

const Image = styled(BaseImage)``;

export { Image };
export type { ImageProps };
